module.exports = __webpack_public_path__ + "static/scale-model-of-long-beach-california-0fefce732f516cfec4d2e17438cdbce0.png";